export const caretrackerEmr = 'CareTracker';
export const caretrackerAccessOrg = 'Access Health Care Physicians';
export const categoryRequiredEmrs = ['EMA', 'Kareo', 'OncoEMR', 'AllegianceMD', 'Elation', 'CareTracker'];
export const caretrackerProviders = [
  "Abdelmalek, Hend F",
  "Abraham, Michelle R",
  "Abuzarad, Husam ",
  "Access Health Care Physicians LLC, ",
  "Adam, Ian ",
  "Adler, Suzanne E",
  "Aemisegger, James R",
  "Agarwal, Usha ",
  "Aguilera Sifontes, Mayelin ",
  "Ajibola, Olakunle ",
  "Akhter, Syed T",
  "Alaniz, Dorothy R",
  "Alessandroni, Marc A",
  "Ali Mohammed, Suhad S",
  "Ali, Sumbul A",
  "Ali, Syed Wajahat",
  "Alia, Vincent P",
  "Alperstein, Adam ",
  "Alvarez Galban, Edel ",
  "Ameen, John ",
  "Amin, Ehab A",
  "Antoine, Nadine ",
  "Arevalo, Louis ",
  "Armstrong, Marc ",
  "Atfeh, Maria ",
  "Avramides, Adam ",
  "Aziz, Michael ",
  "Babugowda, Lalana ",
  "Baggett, Emmalyn G",
  "Baig, Marya F",
  "Baig, Sarah F",
  "Bailey, Geraldine ",
  "Bailey, Tina ",
  "Balart, Leonor ",
  "Bali, Shammi K",
  "Ballweber, Teige J",
  "Barker, Steven ",
  "Barlatier, Ermite C",
  "Barnes, Shauna L",
  "Barnhurst, Mark A",
  "Bartlett, Nakia E",
  "Bass, Kevin W",
  "Batista, Miguelina ",
  "Baysa, Darlene E",
  "Beene, Chiquilla Z",
  "Benson, Dalton Michael",
  "Bhatia, Anil ",
  "Black, Walter Albert",
  "Blecker SR, Edgar R.",
  "BleckerJR, Edgar ",
  "Bogris Cronin, Anastasia G",
  "Bolis, Lawandy Fawzy",
  "Borodunovich, Kyle J",
  "Bossen, Zoya ",
  "Bowens, Christina A",
  "Bradley, Michelle ",
  "Branton, Chimere Enjuli Moniq",
  "Braun, Connie Jo",
  "Brea, Carlos Y",
  "Briette, Lyse ",
  "Brito, Carmen ",
  "Brown, Lauralee W",
  "Buaquina, Loida V",
  "Burgos, Jose A",
  "Byrne, Stephanie ",
  "Caballero, Melanie ",
  "Cagle, Diedre T",
  "Cajuste, Roseline ",
  "Cannon, Sarah J",
  "Capoocia, Amy Beth",
  "Cardillo, Thomas ",
  "Carmassi, Giuseppe D",
  "Carson, Donald ",
  "Castaneda, Brelin ",
  "Castillo Delgado, Evelyn E",
  "Castro, Rosario ",
  "Castro, Yumey ",
  "Catapia, Jeanny B",
  "Cerna, Michelle D.",
  "Cerna, Vidal A.",
  "Champlin, Lena C",
  "Chaudhary, Jeetendra K.",
  "Cheung, Maximilian P",
  "Choiniere, Benoit O",
  "Churchill, Shelly M",
  "Colbath, Tabitha Starr",
  "Colindres, Socrates ",
  "Conologue, Christa ",
  "Conran, Jennifer ",
  "Contreras, Luis S",
  "Conyers, Matthew W.",
  "Coote, Kiera ",
  "Coots, Jill M",
  "Coppola, Christopher R",
  "Coppola, Nicholas Anthony",
  "Cordero-Ferrer, Yamitza ",
  "Corbin, Michelle L",
  "Craig, James D",
  "Crews, Joshua C.",
  "Crognale, John S",
  "Cruz Diaz, Ana ",
  "Cubero Diaz, Yolanda ",
  "D'Acosta, Charlene E",
  "Dadlani, Sindhu ",
  "Danesi, Carla J",
  "Daniels, Ericka L",
  "Daniels, Krizia ",
  "Davila, Miguel ",
  "Davis, Christine E",
  "De La Barra, Maria A.",
  "De Los Reyes Pupo, Orismelcy ",
  "Decker-Bowe, Dawn M",
  "Delva, Cathlen ",
  "Deneau, Lacey D",
  "Denner, Mark Alan",
  "Desai, Dimple R",
  "Diaz Andres, Odelsa ",
  "Diaz, Ivan ",
  "Dilts-Benson, Lynda ",
  "Dixon, Maribel M",
  "Dodge, Tiffany L",
  "Duren, Amber I",
  "Durfey, Susan M",
  "Durr, Justen T",
  "Dzudza-Sunjic, Adisa ",
  "Ehrsam, Mindy R",
  "Eid, Mohamad ",
  "Eid, Nadia ",
  "Ekanayake, Dhammika ",
  "Elhady, Hend A",
  "Ellingson, Karen L",
  "Eskarous, Marian ",
  "Esmkhani, Cameron C",
  "Esposito, Monica A",
  "Evans, Altavia L",
  "FINNEGAN, DREW ",
  "Faheem, Saad Murtaza ",
  "Fana, Miguel A",
  "Fatima, Hajera ",
  "Felix, Monicka Stella ",
  "Ferguson, Mary A",
  "Foreman, Kihana L",
  "Forrey, Erin L",
  "Franklin, Nancy J",
  "Freeman, Stacy L",
  "Friend, Charles R",
  "Galvan, Juan ",
  "Garcia, Karen ",
  "Garrett, John N",
  "Garry, Sharon ",
  "Germaine, Julie ",
  "Geyvandova, Yana ",
  "Giancarlo, Jocelyn L",
  "Glass, Nathan T",
  "Godoy, Gene ",
  "Gomez Vizcarra, Jorge M",
  "Gonzalez, Javier R",
  "Gonzalez-Mendoza, Mariel ",
  "Gonzalez-Ortiz, Evelyn ",
  "Goodpaster, Dawn ",
  "Gottlieb, Mark S",
  "Gourdet, Diana M",
  "Grabowski, Anita L",
  "Gupta, Lalit K",
  "Hafeez, Sadaf ",
  "Hammarquist, Simonne M",
  "Haney, Anita L",
  "Hanson, Erika E.",
  "Hartzell, Robert L",
  "Hasan, Alina ",
  "Hashmi, Abdullah Muhammad ",
  "Haskett, Jay D",
  "Hatton, Patricia H",
  "Hatz, Elizabeth L",
  "Heredia, Milagro E.",
  "Hernandez Mendez, Francisco J",
  "Hernandez, Ivette ",
  "Herndon, David L",
  "Hodges, Terra C",
  "Hoffman, Stacey ",
  "Holland, Rylee ",
  "Holt, Marykay ",
  "Holt, Michelle J",
  "Howard, Heather A",
  "Howell, Norman S",
  "Hoxie, Sheldon M",
  "Hutchinson, Jessica L",
  "Iyer, Akila A",
  "Jacob, Nirmala Rose",
  "Jacques-Huntley, Karen ",
  "Jara Coello, Yatrid E",
  "Jassal, Navdeep ",
  "Jean Pierre, Lissa M.",
  "Jeannot, Pierrot ",
  "Jennison, Amanda L.",
  "Jensen, Susan E",
  "Jibawi, Abdel K",
  "Jibawi, Mohamad Khalid",
  "Johnson, Kenneth I",
  "Johnstone, Heather ",
  "Joseph Luke, Jaison ",
  "Joseph, Brunel ",
  "Joseph, Grace M",
  "Joy, Alexa J",
  "Juvvadi, Raghu ",
  "Kachhwaha, Kecy ",
  "Kadivar, Hajar ",
  "Kaleem, Sana ",
  "Kapoor, Satish C",
  "Kashlan, Ghiath ",
  "Keith, Alison L",
  "Kelly-Connor, Karen L",
  "Kennerly, Nicole R",
  "Kersey, Brian L",
  "Keyes, Valerie ",
  "Khabra, Jessica K.",
  "Khan, Mohammad H",
  "Khargu, Ashti D",
  "King, Janet L",
  "Kinney, Teresa L",
  "Kirindongo, Edu A",
  "Kossuth, Therese K",
  "Krogmann, Carrie L",
  "Kroll, Brian ",
  "Kronenthal, Charles P",
  "Kronenthal, Gretchen L",
  "Kruger, Ryann J.",
  "Kryzaniak, Katrina ",
  "Kulick, Marina V",
  "Kung, Luke C",
  "Kunzinger, Nicole ",
  "Laird, Michael E",
  "Lakhani, Farah ",
  "Laman, Jennifer ",
  "Lamparelli, Michael P",
  "Lane, Chris A",
  "Laporta, Mark A",
  "Layme, Angie ",
  "Lee, Amanda R",
  "Lemire, Sylvie D",
  "Lemos, Kenneth M",
  "Lerner, Charles E",
  "Lindo Murray, Leshaye ",
  "Liriano Gonzalez, Yudith ",
  "Loebell, James Douglas",
  "Loewenstein, Sharona R",
  "Long, Julia S",
  "Lopez-Valle, Melitza ",
  "Lordeus, Kerri Ann K",
  "Lovell, Jeannine A",
  "Madnani, Harish M",
  "Magana, Richard ",
  "Mahmaljy, Ghiath ",
  "Malone, John D",
  "Malyszko, Stacie D",
  "Marchionna, Linda ",
  "Maric, Olga ",
  "Marin Salvador, Homero ",
  "Markova-Acevedo, Yuliya K",
  "Masood, Asif ",
  "Massanet Rivero, Yary ",
  "Massey, Connie L",
  "Mathew, Tintu T",
  "Mationg, Teodulo R",
  "Maung, Cho Y",
  "Mawhinney-Brignola, Susan M",
  "Mazzoni, Daria ",
  "McCarthy, Brian E",
  "McDonald, Cheryl L",
  "McKee, Kelsey M",
  "Mccray, Kelli C.",
  "Menezes, Lakshmi ",
  "Menezes, Naresh P",
  "Mercado-Miranda, Francis J",
  "Mercedes Encarnacion, Toribio ",
  "Messiah, Nabil ",
  "Milko, Mariya ",
  "Millard, Lynn M.",
  "Miller, David R",
  "Mineo, Mikel J",
  "Mohamed, Emadeldin A",
  "Mohammad, Abu Sayeed",
  "Mohiuddin, Mohammed ",
  "Molano, Raymond ",
  "Monroe, Summer ",
  "Montero, Brettashley S",
  "Moore, Tiffany ",
  "Morales, Kayla C",
  "Morillo-pina, Maria R",
  "Moulton-Gray, Kathryn ",
  "Muddassir, Salman M",
  "Mueller, Michael Bernard",
  "Munoz Delgado, Mayra N",
  "Najarro, Juan C",
  "Natarelli, Korin-Marie ",
  "Nelson, Thelma ",
  "Nguyen, Hoa V",
  "Nicophene, Sukaina ",
  "Nieves Mendez, Lorianne ",
  "Nishat, Seema",
  "Nkwocha, Nwanne J",
  "Nodal, Reinaldo ",
  "Notrica, Mary L",
  "Noveck, Jacob J",
  "Nunez, Ernesto ",
  "Nutter, Kristen A",
  "O Rourke, Robin G",
  "Oberoi , Megha ",
  "Omojero, Ejiro T",
  "Orner, Katrina J",
  "Ortiz, Luis A",
  "Ortiz, Steven Gilbert",
  "Pakbaz, Raziyeh ",
  "Park, Angela K.",
  "Parker, Jennifer L.",
  "Patel, Ashish C",
  "Patel, Chirag Ashok ",
  "Patel, Heetal D",
  "Patel, Janvi ",
  "Patel, Maheshkumar A",
  "Patel, Mangesh B",
  "Patel, Pranavkumar ",
  "Patel, Sheetal ",
  "Patel, Soniya ",
  "Paterniti, Beckalove ",
  "Patsioura, Theodora ",
  "Pedersen Runyan, Verna L",
  "Perez Salgado, Francisco J",
  "Perl, Charles G",
  "Philip, Sherry A",
  "Phillips, Kristen J",
  "Pierre, Jude A",
  "Pierre, Jude-Farley ",
  "Pierre, Nadja M",
  "Pinault, Alexandrine ",
  "Pinto, Courtney A.",
  "Pinto, Dianellys ",
  "Pirani, Shaheen ",
  "Popa, Irina ",
  "Powell, Emily S",
  "Pulsipher, Dan William",
  "Quadri, A H Zehra",
  "Quneibi, Sarah S",
  "Qyra, Eglantina ",
  "Ramos, Ivan A",
  "Randhawa, Amrita ",
  "Rao, Surendar G",
  "Rassool, Tala ",
  "Raxwal, Vinod Kumar",
  "Regis, Theresa ",
  "Reimer, Alexis E.",
  "Relampagos, Makaindig R",
  "Reynolds, Michael B",
  "Riaz, Aasma ",
  "Rice, Patricia ",
  "Rincon, Anali J",
  "Ripley, Lisa L",
  "Rivera Quinones, Luis ",
  "Robinson, Diane J",
  "Rockman, Sherry A",
  "Rodriguez Fernandez, Francisco J",
  "Rodriguez, Jose ",
  "Rodriguez-Fernandez, Melissa C",
  "Roose, Brandy M",
  "Rosa, Brian ",
  "Rosenlieb, Jenette N",
  "Rudelli, Michael ",
  "Rutherford, Andrew L",
  "Rutherford, Tracy G.",
  "Saba, Rashid I",
  "Saifuddin, Fatima ",
  "Saigal, Kanta ",
  "Sallah, Mahmoud W",
  "Sanders, Judith A",
  "Sanka, Srinivas ",
  "Sanon, Natalie ",
  "Sapone, Christine ",
  "Sarkar, Rajesh ",
  "Sassano, David J",
  "Satodiya, Mukesh B",
  "Sawyer, Jerrica S",
  "Schickley, Susan K",
  "Sciarrino, Wanda J",
  "Scunziano-Singh, Maria G",
  "Senthilkumaran, Princily ",
  "Shah, Anantkumar M",
  "Shah, Apurva B",
  "Shah, Nina N.",
  "Shah, Samir M",
  "Shastri, Milind J",
  "Shaver, Michael ",
  "Sheth, Jatin N",
  "Shrestha, Devaki ",
  "Siddiq, Danish M",
  "Singh, Mala ",
  "Singh, Pariksith ",
  "Sladek, Eric ",
  "Smith, Barbara A",
  "Smith, Bruce P",
  "Snodgrass, Kenneth ",
  "Spencer, Charity E",
  "Spergel, Craig ",
  "Spooner, Heather ",
  "Springer, Andrew K",
  "Stokes, Michelle T",
  "Stoyanov, Veselin S",
  "Stuckert, Shannon K",
  "Sturdivent, Kendale ",
  "Suleyman, Jenelle M",
  "Sullivan, Jasmin L",
  "Sun, Mingjuan ",
  "Sura, Sandeep B",
  "Sylvia, Gregory A",
  "Tambrini, Alex A",
  "Tang, Kai Hoo ",
  "Tariq, Ali ",
  "Tarry, Michelle H",
  "Tavakoli, Keivan ",
  "Tayon, Jessica L",
  "Tehranchi, Leah ",
  "Terry, Jennifer ",
  "Tharp, Jeremy L",
  "Tommolino, Maria L.",
  "Torres, Jaime ",
  "Tucci, Rosario ",
  "Tulier-Pastewski, Waleska ",
  "Usman, Sadiya ",
  "Valentin, Princess ",
  "Valdes, Ana B",
  "Varkala, Sreelatha ",
  "Varlakov, Grigor J",
  "Vaziri, Ali A",
  "Velasquez, Rafael ",
  "Vennamaneni, Manjusri ",
  "Vinje, Nathaniel ",
  "Vo, Julie L",
  "Wainscott, Elizabeth M",
  "Wamsley, Tamara ",
  "Ware, Lisa ",
  "Webb, Allison N.",
  "Weiner, Mitchell A",
  "Weiss, Henry J",
  "Willis, Steven Grant",
  "Winn, Angela M",
  "Wisser, Elizabeth K",
  "Witter, Douglas Alan",
  "Wolf, Demytra K",
  "Wozniak, Joshua ",
  "Wright, Cherie M",
  "Wright, LeAnne K",
  "Wu, Vincent ",
  "Yadlapalli, Navin Krishna",
  "Yopp, Megan A",
  "Zambrano, Lizbeth L",
  "Ziarani, Azadeh K",
  "Zizza, Richard L"
];
export const resultsTable = [
  {
    title: 'Patient Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Patient DOB',
    dataIndex: 'dob',
    key: 'dob',
  },
  {
    title: 'Patient MRN',
    dataIndex: 'mrn',
    key: 'mrn',
  }
];
export const policyTypes = [
  'EPO',
  'Group Health Plan (GHP)',
  'HMO',
  'IPA',
  'Medicare Advantage',
  'PPO',
  'POS',
  'Other',
  'Commercial - Other',
  'ACA Exchange',
  'CHAMPVA',
  'CHIP',
  'FECA (INC BLK LUNG)',
  'Medicare',
  'Medicaid',
  'Tricare',
  'Government - Other',
];
export const priorityOptions = ['Normal', 'High', 'STAT'];
export const taskOptions =  [
  'Authorization', 'Communication', 'Fax', 'Notify', 'Obtain', 'Order', 'Pathology', 'Prescribe', 'Reassure',
  'Recall', 'Re-Evaluate', 'Refer', 'Return To Clinic', 'Review', 'Schedule', 'Sign', 'Test',
];
export const taskDetailsOptions = ['Additional Testing', 'Benign', 'Claim Review', 'Discuss at Follow-up', 'Follow-up Appt', 'Labs', 'PCP',
  'Medication', 'Normal', 'No Further Treatment', 'Procedure', 'Referring Provider', 'Results', 'Sign/Cosign',
  'Surgery',
];
export const authorizationTypeOptions = ['Authorization', 'Referral'];
